import React from "react"
import {
    Steps,
    Button,
    message,
    SuiNumber,
    SuiInput,
    SuiSelect,
    SuiForm,
} from "@sudy/sui-react"
// import optionsStore from './stores/optionsStore';
import optionsStore from "../../stores/optionsStore"
import { Result } from "antd"
import { observable } from "mobx"
import { observer } from "mobx-react"
import postStore from "../../stores/postStore"
import { $attrs } from "@sudy/sui-react/lib/sui/bind"
import apis from "../../util/urls"
import $ from "jquery"


class BindEmail extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            current: 0,
            count: props.count || 60,
            over: true,
        }
    }

    sendMsg() {
        const _this = this
        const { count } = this.state
        if (count === 1) {
            this.setState({
                count: this.props.count,
                over: true,
            })
        } else {
            this.setState({
                count: count - 1,
                over: false,
            })
            setTimeout(this.sendMsg.bind(this), 1000)
        }
    }

    // 获取邮箱验证码
    sendCode() {
        var ts = this;
        if (this.checkValid()) {
            const emailCode = this.EmailNode.getValue()
            
            $.ajax({
                url: apis.sendEmailCode,
                type: "post",
                dataType: "json",
                data: { email: emailCode },
                success: function (response) {
                    if (response.resultCode === 0) {
                        message.info("验证码发送成功");
                        ts.sendMsg()
                    } else {
                        message.warning(response.errorMsg)
                    }
                },
                error: function (xhr) {
                    message.warning("验证码发送失败")
                },
                complete: function () {},
            })
        }
    }

    /**
     * 校验电话号码
     */
    checkValid() {
        var email =
            this.EmailNode &&
            this.EmailNode.getValue &&
            this.EmailNode.getValue().trim()
        console.log(this.EmailNode.getValue())
        if (
            /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(
                email
            ) === false
        ) {
            message.info("请输入正确的邮箱地址")
            return false
        }
        return true
    }

    // 获取参数
    getValue() {
        if (!this.bindEmailForm.verify()) {
            // message.info("请检查输入项")
            return false
        } else {
            console.log(this.bindEmailForm.getFieldsValue())
            return this.bindEmailForm.getFieldsValue()
        }
    }

    queryData(cur) {
        $.ajax({
            url: this.steps[cur].url,
            type: "post",
            dataType: "json",
            data: this.getParams(),
            success: function (response) {},
            error: function (xhr) {},
            complete: function () {},
        })
    }

    render() {
        const { count, over } = this.state
        return (
            <div>
                <SuiForm
                    bind={postStore}
                    ref={(node) => {
                        this.bindEmailForm = node
                    }}
                >
                    <div className="app-item">
                        {/* <p>
                            <span className="ids-star">*</span>邮箱地址：
                        </p> */}
                        <SuiInput
                            ref={(node) => (this.EmailNode = node)}
                            name="email"
                            style={{ width: "100%" }}
                            required
                            tip="请输入邮箱地址"
                            defaultValue={""}
                            placeholder="请输入邮箱地址"
                        />
                    </div>

                    <div className="app-item">
                        {/* <p>
                            <span className="ids-star">*</span>邮箱验证码：
                        </p> */}
                        <SuiInput
                            name="code"
                            addonAfter={
                                <label
                                    style={{ padding: 8 }}
                                    onClick={(e) => this.sendCode()}
                                >
                                    {over ? "发送验证码" : `${count} 秒后重发`}
                                </label>
                            }
                            placeholder="请输入验证码"
                            required
                            tip="请输入验证码"
                        />
                    </div>
                </SuiForm>
            </div>
        )
    }
}
export default BindEmail
